var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrowSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55396 6.03379H0.702584C0.503519 6.03379 0.336655 5.96646 0.201993 5.8318C0.067331 5.69714 0 5.53028 0 5.33121C0 5.13214 0.067331 4.96528 0.201993 4.83062C0.336655 4.69596 0.503519 4.62863 0.702584 4.62863H8.55396L5.1113 1.18596C4.97078 1.04545 4.90345 0.881509 4.90931 0.694153C4.91516 0.506797 4.98835 0.342861 5.12887 0.202344C5.26938 0.0735372 5.43332 0.00620616 5.62067 0.000351292C5.80803 -0.00550358 5.97197 0.0618274 6.11248 0.202344L10.7495 4.8394C10.8198 4.90966 10.8696 4.98577 10.8988 5.06774C10.9281 5.14971 10.9427 5.23753 10.9427 5.33121C10.9427 5.42489 10.9281 5.51271 10.8988 5.59468C10.8696 5.67665 10.8198 5.75276 10.7495 5.82302L6.11248 10.4601C5.98368 10.5889 5.82267 10.6533 5.62946 10.6533C5.43625 10.6533 5.26938 10.5889 5.12887 10.4601C4.98835 10.3196 4.91809 10.1527 4.91809 9.95949C4.91809 9.76627 4.98835 9.59941 5.12887 9.45889L8.55396 6.03379Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowSvg);
export default __webpack_public_path__ + "static/media/rightArrowSvg.55407426b88cfcaec6ef93212572e97c.svg";
export { ForwardRef as ReactComponent };